/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Project_StateInputs */

const en_options_general_project_state = /** @type {(inputs: Options_General_Project_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project State`)
};

const fr_options_general_project_state = /** @type {(inputs: Options_General_Project_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`État du projet`)
};

const de_options_general_project_state = /** @type {(inputs: Options_General_Project_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektstatus`)
};

const it_options_general_project_state = /** @type {(inputs: Options_General_Project_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato del progetto`)
};

const ru_options_general_project_state = /** @type {(inputs: Options_General_Project_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект «Государство»`)
};

const es_options_general_project_state = /** @type {(inputs: Options_General_Project_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado del proyecto`)
};

const zh_cn2_options_general_project_state = /** @type {(inputs: Options_General_Project_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目状态`)
};

const ja_options_general_project_state = /** @type {(inputs: Options_General_Project_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトの状態`)
};

const hi_options_general_project_state = /** @type {(inputs: Options_General_Project_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना राज्य`)
};

const pt_pt2_options_general_project_state = /** @type {(inputs: Options_General_Project_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto Estado`)
};

/**
* | output |
* | --- |
* | "Project State" |
*
* @param {Options_General_Project_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_project_state = /** @type {((inputs?: Options_General_Project_StateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Project_StateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_project_state(inputs)
	if (locale === "de") return de_options_general_project_state(inputs)
	if (locale === "it") return it_options_general_project_state(inputs)
	if (locale === "ru") return ru_options_general_project_state(inputs)
	if (locale === "es") return es_options_general_project_state(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_project_state(inputs)
	if (locale === "ja") return ja_options_general_project_state(inputs)
	if (locale === "hi") return hi_options_general_project_state(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_project_state(inputs)
	return en_options_general_project_state(inputs)
});